import React from 'react';
import './Header.css';

export default function HeaderLogin() {
  return (
    <div className="header-login">
        <h1 className="heading-login">Feedback</h1>
        <p className="content-login">Add your products and give us your valuable feedback</p>
    </div>
  )
}
